// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LinkModal_bi__tc48W {
  display: flex;
  text-align: right;
  margin: 0;
}
.LinkModal_bi__link__G6ZHm {
  text-decoration: underline;
}

.LinkModal_shareBtns__A6u8H {
  display: flex;
  margin-top: 5rem;
  align-items: center;
}

.LinkModal_ai__GzPY5 {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 3rem 5rem 3rem 5rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  height: 50rem;
  gap: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
}
@media only screen and (max-width: 56.25em) {
  .LinkModal_ai__GzPY5 {
    height: auto;
  }
}
.LinkModal_ai__line__ibj\\+Q {
  border-top: 1px solid var(--color-grey-2);
}
.LinkModal_ai__copy__Ek2l5 {
  display: flex;
  cursor: pointer;
  width: 38rem;
  padding: 2rem;
  background-color: var(--color-primary-7);
  align-items: center;
  justify-content: center;
}
.LinkModal_ai__copy__Ek2l5:hover {
  background-color: var(--color-primary-4);
  color: var(--color-white);
  font-weight: 700;
}
.LinkModal_ai__copy__Ek2l5 > :not(:last-child) {
  margin-right: 2rem;
  font-size: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Inventory/LinkModal.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,iBAAA;EACA,SAAA;AADJ;AAGI;EACI,0BAAA;AADR;;AAKA;EACI,aAAA;EACC,gBAAA;EACA,mBAAA;AAFL;;AAIA;EACC,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;EACA,SAAA;EACA,4CAAA;AADD;AAGC;EAXD;IAYE,YAAA;EAAA;AACF;AAEC;EACC,yCAAA;AAAF;AAGC;EACC,aAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,uBAAA;AADF;AAGE;EACC,wCAAA;EACA,yBAAA;EACA,gBAAA;AADH;AAIE;EACC,kBAAA;EACA,eAAA;AAFH","sourcesContent":["@import '../variables/breakpoints';\n\n.bi {\n    display: flex;\n    text-align: right;\n    margin: 0;\n\n    &__link {\n        text-decoration: underline;\n    }\n}\n\n.shareBtns {\n    display: flex;\n     margin-top: 5rem;\n     align-items: center;\n}\n.ai {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbox-sizing: border-box;\n\tpadding: 3rem 5rem 3rem 5rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-white);\n\theight: 50rem;\n\tgap: 2rem;\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\n\t@media only screen and (max-width: $bp-900) {\n\t\theight: auto;\n\t}\n\n\t&__line {\n\t\tborder-top: 1px solid var(--color-grey-2);\n\t}\n\n\t&__copy {\n\t\tdisplay: flex;\n\t\tcursor: pointer;\n\t\twidth: 38rem;\n\t\tpadding: 2rem;\n\t\tbackground-color: var(--color-primary-7);\n\t\talign-items: center;\n\t\tjustify-content: center;\n\n\t\t&:hover {\n\t\t\tbackground-color: var(--color-primary-4);\n\t\t\tcolor: var(--color-white);\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 2rem;\n\t\t\tfont-size: 3rem;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bi": `LinkModal_bi__tc48W`,
	"bi__link": `LinkModal_bi__link__G6ZHm`,
	"shareBtns": `LinkModal_shareBtns__A6u8H`,
	"ai": `LinkModal_ai__GzPY5`,
	"ai__line": `LinkModal_ai__line__ibj+Q`,
	"ai__copy": `LinkModal_ai__copy__Ek2l5`
};
export default ___CSS_LOADER_EXPORT___;
